import { Button, Tooltip } from "@mui/material";
import React, { useEffect, useState } from "react";
import { API_PATH } from "../../server-data";
import { axiosAuth } from "../../services/interceptor";
import { Select } from "antd";
import { naicCodeMap, naicCodes } from "./data";
import { toastMessage } from "../../helper";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

export default function CategoryMapping(props: any) {
  const [data, setData] = useState<any>([]);
  const { Option } = Select;
  const startFileUpload = () => {
    props.proceedToUpload(true);
  };
  const updateCategory = (item: any) => {
    console.log(data);
    axiosAuth
      .put(API_PATH().apis.categoryMapping, {
        id: item.id,
        code: item.updated_code,
        source: item.updated_source,
      })
      .then((res) => {
        console.log(item);
        item.mapped_code = item.updated_code;
        item.pw_emission_source = item.updated_source;
        item.updated = false;
        setData(JSON.parse(JSON.stringify(data)));
      });
  };

  const updateCategoryCode = (e: any, item: any) => {
    item.updated_code = e.split(" ")[0];
    item.updated_source = e.split(" ").slice(1).join(" ");
    // item.mapped_code = e.split(" ")[0];
    if (item.updated_code !== item.mapped_code) {
      item.updated = true;
    }
    setData([...data]);
  };
  useEffect(() => {
    handleUpload(props.file.file_path, props.file.file_name);
  }, []);
  let [mappingInProgress, setMappingInProgress] = useState(false);
  const handleUpload = (url: string, name: string) => {
    toastMessage("Automapping Started", "success");
    setMappingInProgress(true);
    let company = localStorage.getItem("company") || "{}";
    let businessUnit = localStorage.getItem("currentBusinessUnit") || "{}";
    let controller = new AbortController();
    axiosAuth
      .post(
        API_PATH().apis.categoryMapping,
        {
          url: url,
          name: name,
          company: JSON.parse(company).id,
          businessUnit: JSON.parse(businessUnit).id,
        },
        {
          signal: controller.signal,
          timeout: 600000,
        }
      )
      .then((res) => {
        console.log(res.data);
        setMappingInProgress(false);
        toastMessage("Upload Completed", "success");
        res.data.success.map(
          (item: any) => (item.updated_code = item.mapped_code)
        );
        setOldIndex(
          res.data.success.filter((item: any) => {
            let today = new Date();
            today.setHours(0);
            return new Date(item.created) > today;
          }).length - 1
        );
        setData(res.data.success);
      });
  };

  let [oldIndex, setOldIndex] = useState(-1);

  return (
    <>
      <div style={{ height: "100%", overflow: "auto" }}>
        {mappingInProgress ? (
          <b>&nbsp;&nbsp;Mapping in progress. This may take some time.</b>
        ) : (
          <div className="flex">
            <div style={{ marginRight: "10px" }}>
              <b>S.No</b>
            </div>
            <div style={{ width: "55%" }}>
              <b>Given Description</b>
            </div>
            <div style={{ width: "35%" }}>
              <b>Identified Mapping</b>
            </div>
          </div>
        )}
        {data.length
          ? data.map((item: any, index: any) => (
              <>
                <div
                  className="flex my-1 items-center"
                  style={{ margin: "2.5%", marginRight: "0px" }}
                >
                  <div style={{ marginRight: "10px" }}>{index + 1}</div>
                  <div style={{ width: "50%" }}>{item.description}</div>
                  <Select
                    onChange={(e) => updateCategoryCode(e, item)}
                    showSearch
                    value={
                      item.updated_code + " " + naicCodeMap[item.updated_code]
                        ? naicCodeMap[item.updated_code]
                        : "UnMapped"
                    }
                    dropdownStyle={{ zIndex: 10000 }}
                    style={{ width: "35%", marginRight: "1%" }}
                  >
                    {naicCodes.map((eachCode) => (
                      <Option
                        value={eachCode.code + " " + eachCode.description}
                      >
                        {eachCode.code + " " + eachCode.description}
                      </Option>
                    ))}
                  </Select>
                  <div style={{ width: "3%", marginRight: "1%" }}>
                    {item.pw_emission_source ? (
                      ""
                    ) : (
                      <Tooltip title="Emission factor not found.Please select nearby category.">
                        <WarningAmberIcon style={{ color: "orange" }} />
                      </Tooltip>
                    )}
                  </div>
                  {item.updated ? (
                    <Button
                      style={{ width: "5%", color: "white" }}
                      variant="contained"
                      onClick={(e) => updateCategory(item)}
                    >
                      Set
                    </Button>
                  ) : (
                    ""
                  )}
                </div>
                {oldIndex == index && data.length != oldIndex + 1 ? (
                  <div className="text-center">
                    Older
                    <hr />
                  </div>
                ) : (
                  ""
                )}
              </>
            ))
          : ""}
        {data.length ? (
          <div>
            <Button
              style={{
                width: "15%",
                color: "white",
                display: "block",
                margin: "auto",
              }}
              variant="contained"
              disabled={
                data.filter((item: any) => item.pw_emission_source == null)
                  .length != 0
              }
              onClick={(e) => startFileUpload()}
            >
              Proceed
            </Button>
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  );
}
